import React, { memo, useState, useContext } from "react";
import { Modal, Row, Col, Form, Button, Spinner } from "react-bootstrap";
import { useSelector, useDispatch } from 'react-redux';
import { closeModal } from "slices/stillageCollections";
import FalconCloseButton from "components/common/FalconCloseButton";
import TagsInput from "react-tagsinput";
import { toast } from "react-toastify";
import { StillageCollectionDataContext } from "context/Context";
import { addStillageToJob } from "services/stillageCollections";

const AddStillageToCollection = () => {
    const [loading, setLoading] = useState(false);
    const [stillageNos, setStillageNos] = useState([]);
    const { addStillage: { show, data: { collectionNote, collectionDate } } } = useSelector(state => state.stillageCollections);
    const { getCollectionData, collectionDates } = useContext(StillageCollectionDataContext);
    const dispatch = useDispatch();

    const handleClick = async () => {
        setLoading(true);
        try {
            const res = await addStillageToJob(collectionNote, collectionDate, stillageNos);

            if (res.message) {
                toast.error('Something went wrong! ', res.message)
                return;
            }

            toast.success(`${stillageNos.join(', ')} added to ${collectionNote}!`);
            setTimeout(() => {
                getCollectionData(collectionDates.start, collectionDates.end);
                dispatch(closeModal())
            }, 500)
        } catch (err) {
            toast.error('Something went wrong! ', err);
        } finally {
            setLoading(false);
        }
    }

    return (
        <Modal show={show}>
            <Modal.Header>
                <Modal.Title>Mark A Stillage As Collected - <span className="d-block">{collectionNote}</span></Modal.Title>
                <FalconCloseButton onClick={() => dispatch(closeModal())} /></Modal.Header>
            <Modal.Body>
                <p className="mb-3 p-2">Enter stillage No<small>(s)</small>. below and press confirm to add them to this job and mark them as collected.</p>
                <Row>
                    <Col xs={2}><Form.Label>Stillage No<small>(s)</small>.</Form.Label></Col>
                    <Col>
                        <TagsInput
                            addOnBlur
                            value={stillageNos}
                            onChange={e => setStillageNos(e)}
                            onChangeInput={e => console.log(e)}
                            validate={tag => {
                                const valid = !isNaN(Number(tag));
                                if (!valid) toast.error('Please only enter numeric characters');
                                return valid;
                            }}
                            onlyUnique={true}
                            tagProps={{
                                className: 'react-tagsinput-tag bg-primary bg-gradient text-light shadow-sm badge py-2',
                                classNameRemove: 'react-tagsinput-remove'
                            }}
                            inputProps={{
                                className: 'react-tagsinput-input',
                                placeholder: 'Enter stillage numbers...'
                            }}
                        />
                    </Col>
                </Row>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    disabled={loading}
                    onClick={handleClick}>
                    Confirm {loading && <span><Spinner size="sm" variant="light" /></span>}</Button>
                <Button
                    variant="secondary"
                    onClick={() => dispatch(closeModal())}
                    disabled={loading}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default memo(AddStillageToCollection);